import React from "react";

const AboutFounderMessageSection = ({ message }) => {
  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Background Image Container with Dual Shadows */}
      <div className="absolute inset-0">
        {/* Top Shadow Gradient */}
        <div className="absolute top-0 left-0 right-0 h-14 md:h-40 z-10 bg-gradient-to-b from-app-background to-transparent"></div>

        {/* Main Image */}
        <img
          src="/images/about-us-page/about-founder-message-image.jpeg"
          alt="Founder Message"
          className="w-full h-full object-cover object-center grayscale opacity-40"
        />

        {/* Bottom Shadow Gradient */}
        <div className="absolute bottom-0 left-0 right-0 h-40 z-10 bg-gradient-to-t from-app-background to-transparent"></div>
      </div>

      {/* Text Content */}
      <div className="relative z-20 flex flex-col justify-center items-start md:items-center h-full text-start md:text-center px-4 md:px-20 md:py-36">
        <p className="text-2xl md:text-5xl font-bold text-white mb-4 drop-shadow-lg leading-normal tracking-wide">
          {message}
        </p>

        {/* <p className="text-base md:text-3xl font-medium text-[#D9D9D9] mt-1 md:mt-6 mb-4 drop-shadow-lg leading-normal tracking-wide">
          <AboutUsUserCard
            userProfilePic="/images/about-us-page/founder-image.jpeg"
            username="Gaurav Dixit"
            position="Founder & CEO, Datapixl"
          />
        </p> */}
      </div>
    </div>
  );
};

export default AboutFounderMessageSection;
